'use client';

import * as React from 'react';
import Link from 'next/link';
import { ArrowRightIcon, SparklesIcon, VideoIcon } from 'lucide-react';

import { routes } from '@workspace/routes';
import { buttonVariants } from '@workspace/ui/components/button';
import { cn } from '@workspace/ui/lib/utils';
import { ComingSoonModal } from '../coming-soon-modal';

export function CallToAction(): React.JSX.Element {
  const [showComingSoon, setShowComingSoon] = React.useState(false);
  
  return (
    <section className="py-24 lg:py-32 bg-gradient-to-b from-[#0E0F1A] to-[#1A1B29]">
      <div className="container px-6">
        <div className="mx-auto max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-[#4531FF]/20 to-[#00C6FF]/20 text-[#00C6FF] text-sm font-medium mb-6 border border-[#4531FF]/20">
            <SparklesIcon className="h-4 w-4" />
            No experience needed
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 tracking-tight leading-tight">
            Ready to create your first video?
          </h2>
          <p className="text-lg lg:text-xl text-[#9EA1AE] mb-12 max-w-2xl mx-auto leading-relaxed">
            Type any idea—music video, commercial, or film—and watch it come to life. 
            Start free—no credit card needed.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={() => setShowComingSoon(true)}
              className={cn(
                'bg-gradient-to-r from-[#4531FF] to-[#00C6FF] text-white text-lg font-semibold px-8 py-4 rounded-full hover:shadow-lg transition-all duration-200 hover:scale-105 hover:from-[#3420E5] hover:to-[#00A3D9] inline-flex items-center'
              )}
            >
              Start Creating Videos Free
              <ArrowRightIcon className="ml-2 h-4 w-4" />
            </button>
            <Link
              href="#interactive-demo"
              className={cn(
                'text-lg px-8 py-4 group border-2 border-[#4531FF] hover:border-[#00C6FF] hover:bg-white/5 transition-all rounded-full bg-transparent text-white font-medium inline-flex items-center gap-2'
              )}
            >
              <VideoIcon className="mr-2 h-4 w-4" />
              Watch Demo
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-16 max-w-2xl mx-auto">
            <div className="text-center">
              <p className="text-3xl font-medium text-[#00C6FF] mb-1">Beta</p>
              <p className="text-sm text-[#9EA1AE]">Early access</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-medium text-[#00C6FF] mb-1">3 min</p>
              <p className="text-sm text-[#9EA1AE]">From idea to video</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-medium text-[#00C6FF] mb-1">Free</p>
              <p className="text-sm text-[#9EA1AE]">To get started</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Coming Soon Modal */}
      <ComingSoonModal isOpen={showComingSoon} onClose={() => setShowComingSoon(false)} />
    </section>
  );
}